/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const ENTERPRISE_SAVED_RECIPIENT = 'MFE/MBP-CHECKOUT/ENTERPRISE_SAVED_RECIPIENT';
export const ENTERPRISE_SAVED_RECIPIENT_SUCCESS = 'MFE/MBP-CHECKOUT/ENTERPRISE_SAVED_RECIPIENT_SUCCESS';
export const ENTERPRISE_SAVED_RECIPIENT_FAILED = 'MFE/MBP-CHECKOUT/ENTERPRISE_SAVED_RECIPIENT_FAILED';
export const ENTERPRISE_PROCEED_SAVED_RECIPIENT = 'MFE/MBP-CHECKOUT/ENTERPRISE_PROCEED_SAVED_RECIPIENT';

export const ENTERPRISE_SAVED_RECIPIENT_GIFT_MESSAGE = 'MFE/MBP-CHECKOUT/ENTERPRISE_SAVED_RECIPIENT_GIFT_MESSAGE';
export const ENTERPRISE_SAVED_RECIPIENT_GIFT_MESSAGE_SUCCESS = 'MFE/MBP-CHECKOUT/ENTERPRISE_SAVED_RECIPIENT_GIFT_MESSAGE_SUCCESS';
export const ENTERPRISE_SAVED_RECIPIENT_GIFT_MESSAGE_FAILED = 'MFE/MBP-CHECKOUT/ENTERPRISE_SAVED_RECIPIENT_GIFT_MESSAGE_FAILED';
export const ENTERPRISE_QAS_SAVED_RECIPIENT = 'MFE/MBP-CHECKOUT/ENTERPRISE_QAS_SAVED_RECIPIENT';

export const ENTERPRISE_SAVED_ADDRESS_BOOK = 'MFE/MBP-CHECKOUT/ENTERPRISE_SAVED_ADDRESS_BOOK';
export const ENTERPRISE_SAVED_ADDRESS_BOOK_SUCCESS = 'MFE/MBP-CHECKOUT/ENTERPRISE_SAVED_ADDRESS_BOOK_SUCCESS';
export const ENTERPRISE_SAVED_ADDRESS_BOOK_FAILED = 'MFE/MBP-CHECKOUT/ENTERPRISE_SAVED_ADDRESS_BOOK_FAILED';
